export default "__VITE_ASSET__DRkat4Ll__"